/* eslint-disable import/no-anonymous-default-export */
import { PublicFranchiseBranding } from "../../services/Franchises/Franchises.type";
import { resolveFranchiseSlugFromPath } from "../../utils/franchise/franchiseSlug";
import {
  SET_FRANCHISE_BRANDING,
  SET_FRANCHISE_ERROR,
  SET_FRANCHISE_LOADING,
  SET_FRANCHISE_SLUG,
} from "./actionTypes";

export type FranchiseState = {
  slug: string | null;
  branding: PublicFranchiseBranding | null;
  loading: boolean;
  error: string | null;
};

const initialState: FranchiseState = {
  slug: typeof window !== "undefined" ? resolveFranchiseSlugFromPath() : null,
  branding: null,
  loading: false,
  error: null,
};

export default (state: FranchiseState = initialState, action: any): FranchiseState => {
  switch (action.type) {
    case SET_FRANCHISE_SLUG:
      return {
        ...state,
        slug: action.payload,
      };
    case SET_FRANCHISE_BRANDING:
      return {
        ...state,
        branding: action.payload,
        loading: false,
        error: null,
      };
    case SET_FRANCHISE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_FRANCHISE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
